import { environment } from '@app-environments/environment';
import { Injectable } from '@angular/core';
import { API_ROUTES } from '@app-shared/constants/routes/api.routes';
import { ApiRequest } from '@app-services/api/api.request';

const API_URL = environment.feUrl;
const { version } = API_ROUTES.fe;

@Injectable({
  providedIn: 'root',
})
export class FeClient {
  constructor(private apiRequest: ApiRequest) {}

  async getVersion(): Promise<{ version: string }> {
    return await this.apiRequest.get(`${API_URL}${version}`);
  }
}
